<script>
import { stepNumbers } from '@/utils/stepNumbers'
import { CalcTypes } from '@/utils/types'

export default {
  name: 'ModalMixin',
  data: () => ({
    isModalOpen: false,
    modalAction: null,
    modalData: null,
    src: null
  }),
  methods: {
    onZoom(evt) {
      this.src = evt.url
      this.modalAction = 'zoom'
      this.isModalOpen = !this.isModalOpen
    },
    handleModalAction(evt) {
      switch (evt.action) {
        case 'delete':
          if (this.sectors.length > 1) {
            this.$store.commit('DELETE_SECTOR', { index: this.deleteIndex })
            this.navigate({ action: 'switch', index: this.deleteIndex === 0 ? this.deleteIndex : this.deleteIndex - 1 })
          }
          break
        case 'select':
          const property = this.sector.currentStep === stepNumbers.systemFilter ? 'system' : 'construction'
          this.$store.commit('UPDATE_SECTOR', {
            index: this.sectorIndex,
            property,
            value: evt.value
          })

          if (property === 'system') {
            const hasProAlgorithm = evt?.value?.calcTypes?.map((type) => type.toLowerCase())?.includes(CalcTypes.pro)
            const algorithm = hasProAlgorithm && !this.sector.constructionType.isCombinedLocation
              ? CalcTypes.pro : CalcTypes.lite

            this.$store.commit('UPDATE_SECTOR', {
              index: this.sectorIndex,
              property: 'algorithm',
              value: algorithm
            })
          }
          break
        case 'close':
          this.$store.commit('UPDATE_MODAL', { property: 'selectedSystem', value: null })
          break
        default:
          break
      }
      this.isModalOpen = !this.isModalOpen
      this.modalData = null
      this.modalAction = null
      this.src = null
    }
  }
}
</script>
